import { TextField } from '@mui/material'
import { AutocompleteProps } from '@mui/material/Autocomplete'

import * as S from './styles'

interface IAutocompleteProps<T>
  extends AutocompleteProps<string | T, boolean, boolean, boolean> {
  variant?: 'outlined' | 'filled' | 'standard'
  label?: string
  placeholder?: string
  loading?: boolean
  loadingText?: React.ReactNode
  getOptionLabel: (option: string | T) => string
}

const Autocomplete = (props: IAutocompleteProps<any>) => {
  return props.loading ? (
    <S.AutoComplete
      {...props}
      key={new Date().getTime()}
      disabled
      renderInput={(params) => (
        <TextField {...params} label={props.loadingText || 'Carregando...'} />
      )}
    />
  ) : (
    <S.AutoComplete {...props} />
  )
}

export { Autocomplete }
export type { IAutocompleteProps }
